<template>
    <div v-loading="loading">
        <el-date-picker
            v-model="dateVal"
            type="datetime"
            :placeholder="placeholder"
            value-format="timestamp"
            :format="format"
            :default-value="defaultValue"
            popper-class="holiday-date-picker"
            :picker-options="pickerOptions"
            :disabled="disabled"
            :editable="editable"
            style="width: 100%"
            placement="top"
            @calendar-change="handleCalendarChange"
        ></el-date-picker>
    </div>
</template>

<script>
import {getHolidayData} from '@/api/album';
export default {
    name: 'holiday',
    props: {
        value: [Number, String, Date],
        placeholder: {
            type: String,
            default: '请选择日期'
        },
        format: {
            type: String,
            default: 'yyyy-MM-dd HH:00'
        },
        disabled: Boolean,
        editable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        const today = new Date();
        return {
            loading: false,
            dateVal: this.value,
            currtYear: today.getFullYear(),
            currentMonth: today.getMonth() + 1,
            holidayData: {},
            // 缓存已经加载的月份（格式为'YYYY-MM'）
            cachedMonths: new Set(),
            // 待加载的月份去重集合
            pendingLoadMonths: new Set(),
            // 用于延迟加载的定时器
            loadTimer: null,
            minWorkDate: null, // 存储最小工作日时间戳
            defaultPanelDate: null,
            pickerOptions: {
                cellClassName: this.handleCellClassName,
                disabledDate: time => {
                    if (!this.minWorkDate) return false;
                    const date = new Date(time);
                    return date.getTime() < this.minWorkDate;
                    // // 1. 禁止选择小于最小工作日的日期
                    // if (date.getTime() < this.minWorkDate) {
                    //     return true;
                    // }
                    // // 2. 处理周末且非补班的情况
                    // const year = date.getFullYear();
                    // const month = (date.getMonth() + 1).toString().padStart(2, '0');
                    // const day = date
                    //     .getDate()
                    //     .toString()
                    //     .padStart(2, '0');
                    // const dateStr = `${year}-${month}-${day}`;
                    // const status = this.holidayData[dateStr];
                    // const dayOfWeek = date.getDay();
                    // if (dayOfWeek === 0 || dayOfWeek === 6) {
                    //     if (status === 2) return false;
                    //     return true;
                    // }
                    // if (status === 1) return true;
                    // return false;
                }
            },
            defaultValue: null
        };
    },
    computed: {
        // 计算当前月及相邻月份（共3个月）
        adjacentMonths() {
            return this.calculateMonths(this.currtYear, this.currentMonth);
        }
    },
    watch: {
        value(newVal) {
            this.dateVal = newVal;
        },
        dateVal(newVal) {
            this.$emit('input', newVal);
        }
    },
    mounted() {
        // 初始化时加载默认月份及相邻月份
        this.ensureMonthsCached(this.adjacentMonths);
        this.calculateMinWorkDate();
    },
    methods: {
        // 计算最小工作日：用户可以选择3个工作日后的任何一天，即时当天是节假日
        //举例：今天是2025年7月1日（周二），则用户可以选择7月5日（周六）上线，以及7月5日后的任何一天作为期望上线日期
        calculateMinWorkDate() {
            const startDate = new Date();
            startDate.setHours(0, 0, 0, 0);
            const currentDate = new Date(startDate);
            let workdayCount = 0;
            // 从明天开始计算
            currentDate.setDate(currentDate.getDate() + 1);
            // 记录找到的工作日日期
            const workdays = [];
            // 找齐3个工作日
            while (workdayCount < 3) {
                if (this.isWorkday(currentDate)) {
                    workdayCount++;
                    workdays.push(new Date(currentDate));

                    // 找到第3个工作日就停止
                    if (workdayCount === 3) break;
                }

                // 无论是否是工作日，都继续检查下一天
                currentDate.setDate(currentDate.getDate() + 1);
            }
            // 如果有找到3个工作日，最小日期就是第3个工作日的后一天
            if (workdays.length === 3) {
                const minDate = new Date(workdays[2]);
                minDate.setDate(minDate.getDate() + 1);
                minDate.setHours(0, 0, 0, 0);

                this.minWorkDate = minDate.getTime();
                this.defaultValue = minDate.getTime();

                if (!this.defaultPanelDate) {
                    this.defaultPanelDate = new Date(this.minWorkDate);
                }

                // 确保相关月份数据已加载
                const targetMonth = `${minDate.getFullYear()}-${(minDate.getMonth() + 1).toString().padStart(2, '0')}`;
                this.ensureMonthsCached([targetMonth]);
            }
        },
        // 判断是否为工作日
        isWorkday(date) {
            const dateStr = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date
                .getDate()
                .toString()
                .padStart(2, '0')}`;
            if (this.holidayData[dateStr] !== undefined) {
                return this.holidayData[dateStr] === 0 || this.holidayData[dateStr] === 2; // 2=调休上班日
            }

            // 默认逻辑：周一至周五为工作日
            const dayOfWeek = date.getDay();
            return dayOfWeek !== 0 && dayOfWeek !== 6; // 0=周日, 6=周六
        },
        // 计算当前月及相邻月份（前后各一个月）
        calculateMonths(year, month) {
            const months = [];
            for (let offset = -1; offset <= 1; offset++) {
                const date = new Date(year, month - 1 + offset, 1);
                const y = date.getFullYear();
                const m = date.getMonth() + 1;
                months.push(`${y}-${m.toString().padStart(2, '0')}`);
            }
            return months;
        },

        // 确保传入的月份数组都被缓存
        ensureMonthsCached(months) {
            const toLoadMonths = months.filter(month => !this.cachedMonths.has(month));
            if (toLoadMonths.length === 0) return;

            toLoadMonths.forEach(month => {
                this.cachedMonths.add(month);
                this.fetchHolidayData(month);
            });
        },

        // 处理每个单元格的类名
        handleCellClassName(params) {
            if (!params) return '';

            // 构造日期字符串（用于获取节假日状态）
            const dateStr = `${params.getFullYear()}-${(params.getMonth() + 1).toString().padStart(2, '0')}-${params
                .getDate()
                .toString()
                .padStart(2, '0')}`;
            // 构造月份字符串（用于检查缓存）
            const monthStr = `${params.getFullYear()}-${(params.getMonth() + 1).toString().padStart(2, '0')}`;

            // 检查这个月份是否已被缓存
            if (!this.cachedMonths.has(monthStr)) {
                // 将这个月份添加到待加载队列
                this.pendingLoadMonths.add(monthStr);
                // 清除之前的定时器
                if (this.loadTimer) clearTimeout(this.loadTimer);
                // 设置一个延迟，合并同一帧内的多次调用
                this.loadTimer = setTimeout(() => {
                    const monthsToLoad = [...this.pendingLoadMonths];
                    this.pendingLoadMonths.clear();
                    monthsToLoad.forEach(month => {
                        if (!this.cachedMonths.has(month)) {
                            this.cachedMonths.add(month);
                            this.fetchHolidayData(month);
                        }
                    });
                }, 100);
            }
            // 根据日期设置单元格样式
            const status = this.holidayData[dateStr];
            if (status === 1) return 'holiday-rest';
            if (status === 2) return 'holiday-work';
            const dayOfWeek = params.getDay();
            if (dayOfWeek === 0 || dayOfWeek === 6) {
                return 'weekend';
            }
            return '';
        },

        // 处理日历面板变化事件（月份切换会触发）
        handleCalendarChange(date) {
            if (!date) return;

            // 更新当前年月
            this.currtYear = date.getFullYear();
            this.currentMonth = date.getMonth() + 1;

            // 确保当前月及相邻月份被加载
            this.ensureMonthsCached(this.adjacentMonths);
        },

        // 获取特定月份的节假日数据
        async fetchHolidayData(dateMonth) {
            this.loading = true;
            try {
                const res = await getHolidayData(dateMonth);
                const holidays = res.data?.result || [];
                const newData = {};
                holidays.forEach(item => {
                    if (!item || !item.holiday || item.status === 0) return;
                    try {
                        const timestamp = Number(item.holiday);
                        const dateObj = new Date(timestamp);
                        if (isNaN(dateObj.getTime())) return;
                        const dateStr = `${dateObj.getFullYear()}-${(dateObj.getMonth() + 1).toString().padStart(2, '0')}-${dateObj
                            .getDate()
                            .toString()
                            .padStart(2, '0')}`;
                        newData[dateStr] = item.status;
                    } catch (error) {
                        this.$message.error(error.message || '获取数据失败');
                    }
                });
                this.holidayData = {...this.holidayData, ...newData};
                // 强制更新日期选择器（通过改变key，触发重新渲染）
                this.pickerOptions = {...this.pickerOptions};
                this.calculateMinWorkDate();
            } catch (error) {
                this.$message.error(error.message || '获取数据失败');
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style>
/* 节假日标记样式 */
.holiday-date-picker .el-date-table td.today::after,
.holiday-date-picker .el-date-table td.holiday-rest::after,
.holiday-date-picker .el-date-table td.holiday-work::after {
    content: '';
    position: absolute;
    top: 2px;
    right: 2px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    z-index: 2;
    font-weight: bold;
}
.holiday-date-picker .el-date-table td:not(.prev-month):not(.next-month).weekend {
    color: #ff4d4f !important;
}
.holiday-date-picker .el-date-table td.prev-month.weekend,
.holiday-date-picker .el-date-table td.next-month.weekend {
    color: rgba(255, 77, 79, 0.4) !important;
}
.holiday-date-picker .el-date-table td.disabled.weekend div {
    color: rgba(255, 77, 79, 0.4) !important;
}
.holiday-date-picker .el-date-table td.today::after {
    content: '今';
    background: rgba(24, 144, 255, 0.1);
    color: #1890ff;
}

.holiday-date-picker .el-date-table td.holiday-rest::after {
    content: '休';
    background-color: #ffebee;
    color: #f44336;
}

.holiday-date-picker .el-date-table td.holiday-work::after {
    content: '班';
    background: #000000ba;
    color: #fff;
}

/* 增强单元格定位 */
.holiday-date-picker .el-date-table td {
    position: relative;
}
</style>

